import { Plugin } from "chart.js";

import { getCSSVar } from "@/utils";

const ThemePlugin: Plugin<"line"> = {
  id: "theme",
  install(chart, _args) {
    document.addEventListener("themeChange", () => {
      const scope = document.body.classList.contains("dark")
        ? "dark"
        : "default";
      const scopedCSSVar = (variableName: string) =>
        getCSSVar(variableName, scope);

      const lineColor = scopedCSSVar("--chart-grid-color");
      const textColor = scopedCSSVar("--chart-text-color");

      // These may not exist.
      if (chart.options.scales?.x?.grid)
        chart.options.scales.x.grid.color = lineColor;

      if (chart.options.scales?.y?.grid)
        chart.options.scales.y.grid.color = lineColor;

      if (chart.options.scales?.y?.ticks)
        chart.options.scales.y.ticks.color = textColor;

      if (chart.options.scales?.x2?.ticks)
        chart.options.scales.x2.ticks.color = textColor;

      if (chart.options.scales?.x?.ticks)
        chart.options.scales.x.ticks.color = textColor;

      if (chart.legend?.options?.labels)
        chart.legend.options.labels.color = textColor;

      // chart.reset();
      chart.update();
    });
  },
};

export default ThemePlugin;
